import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'
import './episode.css'
import './transition.css'
import './ketone.css'
import './therapy.css'
import './correction.css'
import './references.css'
import './workflow.css'
import './demo.css'
import './cases.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => navigator.serviceWorker.register('/sw.js').catch(console.error))
}
